import React from 'react';

// material-ui
import { useTheme } from '@material-ui/styles';
import logo from 'assets/images/logo.png';
import logoSvg from 'assets/images/somerston_logo.png';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from '.assets/images/logo-dark.svg';
 * 
 *
 */

//-----------------------|| LOGO SVG ||-----------------------//

const Logo = () => {
    const theme = useTheme();
    const mystyle = {
        background: " #0e203b",
        padding: "10px",
        borderRadius: "10px"
    };
    return (
        <img src={logoSvg} alt="Surmount" height="70" width="180" style={mystyle} />
    );
};

export default Logo;
